import {
  collection,
  where,
  getFirestore,
  getDocs,
  query,
  setDoc,
  getDoc,
  deleteDoc,
  serverTimestamp,
  doc,
  updateDoc,
  orderBy,
  onSnapshot,
} from "firebase/firestore";
import lodash from "lodash";
import { getAuth } from "firebase/auth";
import moment from "moment";
import { chunk } from "lodash";

import { app } from "../../config/config";
import { REF } from "../ref";
import { TYPES } from "./incomeStaff.type";

const firestore = getFirestore(app);
const auth = getAuth();

//------------------------- snap all income by Staff by Date -----------------------------
let incomeSub = [];
export const snapAllIncomeByDate =
  ({ from, to }, callback) =>
  (dispatch) => {
    const owner = auth?.currentUser?.uid;
    selectIncomeByDateSuccess(dispatch, null);
    const cRef = collection(firestore, "incomeStaff");
    const start = moment(from)?.startOf("day").toDate();
    const end = moment(to)?.endOf("day").toDate();
    console.log(start, end);
    const c0 = where("onDate", ">=", start);
    const c1 = where("onDate", "<=", end);
    const c2 = where("owner", "==", owner);
    const qRef = query(cRef, c0, c1, c2);
    const unSub = onSnapshot(qRef, (snapshot) => {
      if (snapshot) {
        const data = snapshot.docs.map((doc) => doc.data());
        selectIncomeByDateSuccess(dispatch, data);
        if (callback) {
          callback();
        }
      }
    });
    incomeSub.push(unSub);
  };

export const unSnapIncome = () => (dispatch) => {
  incomeSub.forEach((subscriber) => {
    subscriber();
  });
  incomeSub.length = 0;
};

//------------------------- get all branch by ownerList -----------------------------
export const getAllBranch =
  ({ branchIdList }, callback) =>
  (dispatch) => {
    if (branchIdList.length > 0) {
      const cRef = collection(firestore, "branch");
      const c0 = where("id", "in", branchIdList);
      const qRef = query(cRef, c0);
      getDocs(qRef).then((snapshot) => {
        if (snapshot) {
          const data = snapshot.docs.map((doc) => doc.data());
          selectAllBrancheSuccess(dispatch, data);
          if (callback) {
            callback();
          }
        }
      });
    } else {
      selectAllBrancheSuccess(dispatch, []);
    }
  };

//------------------------- get user infi by userList -----------------------------

// export const getUserInfo = ({ userIdList }, callback) => (dispatch) => {
//   if (userIdList.length > 0) {
//     const chunks = chunk(userIdList, 10);

//     const promises = chunks.map(chunk => {
//       const cRef = collection(firestore, "user");
//       const c0 = where("id", "in", chunk);
//       const qRef = query(cRef, c0);
//       return getDocs(qRef);
//     });

//     Promise.all(promises).then(snapshots => {
//       const data = snapshots.flatMap(snapshot => snapshot.docs.map(doc => doc.data()));
//       selectUserInfoSuccess(dispatch, data);
//       if (callback) {
//         callback();
//       }
//     });
//   } else {
//     selectUserInfoSuccess(dispatch, []);
//   }
// };

export const getUserInfo =
  ({ userIdList }, callback) =>
  (dispatch) => {
    selectUserInfoSuccess(dispatch, null);
    const cRef = collection(firestore, REF.USER);
    let result = [];
    const promises = lodash.chunk(userIdList, 10)?.map((arr) => {
      const c0 = where("id", "in", arr);
      const qRef = query(cRef, c0);
      return getDocs(qRef).then((snapshot) => {
        if (snapshot) {
          const data = snapshot.docs.map((doc) => doc.data());
          result.push(...data);
        }
      });
    });

    Promise.all(promises)
      .then(() => {
        selectUserInfoSuccess(dispatch, result);
        if (callback) {
          callback({
            status: 200,
            data: result,
          });
        }
      })
      .catch((err) => {
        if (callback) {
          callback({
            status: 500,
            data: err?.message,
          });
        }
      });
  };

//------------------------- dispatch -----------------------------

const selectIncomeByDateSuccess = (dispatch, data) =>
  dispatch({
    type: TYPES.SELECT_ALL_INCOME_SUCCESS,
    payload: data,
  });

const selectAllBrancheSuccess = (dispatch, data) =>
  dispatch({
    type: TYPES.SELECT_ALL_BRANCH_SUCCESS,
    payload: data,
  });

const selectUserInfoSuccess = (dispatch, data) =>
  dispatch({
    type: TYPES.SELECT_USER_INFO_SUCCESS,
    payload: data,
  });

//------------------------- snap all income by Staff by Date -----------------------------
let incomeSub2 = [];
export const snapAllIncomeByBranch =
  ({ from, to, branchId }, callback) =>
  (dispatch) => {
    console.log(from, to, branchId);
    selectIncomeByDateByBranchSuccess(dispatch, null);
    const cRef = collection(firestore, "incomeStaff");
    const start = moment(from)?.startOf("day").toDate();
    const end = moment(to)?.endOf("day").toDate();
    const c0 = where("onDate", ">=", start);
    const c1 = where("onDate", "<=", end);
    const c2 = where("branch", "==", branchId);
    const qRef = query(cRef, c0, c1, c2);
    const unSub = onSnapshot(qRef, (snapshot) => {
      if (snapshot) {
        const data = snapshot.docs.map((doc) => doc.data());
        selectIncomeByDateByBranchSuccess(dispatch, data);
        if (callback) {
          callback();
        }
      }
    });
    incomeSub2.push(unSub);
  };

export const unSnapIncomeByBranch = () => (dispatch) => {
  incomeSub2.forEach((subscriber) => {
    subscriber();
  });
  incomeSub.length = 0;
};

//dispatch

const selectIncomeByDateByBranchSuccess = (dispatch, data) =>
  dispatch({
    type: TYPES.SELECT_ALL_INCOME_BY_BRANCH_SUCCESS,
    payload: data,
  });
